<template>
  <div>
    <center>
      <h1>New Watchlist Department</h1>
      <p>Follow the directions below</p>
    </center>
    <hr>
    <v-btn v-if="!showDepartmentConfirm" @click="goBack()" class="ma-2" color="primary" text><v-icon darkleft>mdi-arrow-left</v-icon>Back</v-btn>
    <center>
      <v-progress-circular v-if="loading" indeterminate color="primary"></v-progress-circular>
        <div v-if="showSelector" id=areaAndServiceSelector>
          <v-form ref="departmentAndServiceForm" v-model="valid" lazy-validation>
            <v-select v-model="countySelected" :items="supportedAreas" :rules="selectorRules" label="County" data-vv-name="select" required></v-select>
            <v-select v-model="serviceSelected" :items="serviceList" :rules="selectorRules" label="Service" data-vv-name="select" required></v-select>
            <v-btn id="submit-button" :disabled="!valid" color="success" @click="getDepartments(countySelected, serviceSelected)">Next</v-btn>
          </v-form>
      </div>
    </center>
    <div class="supportedDepartments" v-if="showDepartments">
      <div class=watchlistItems v-for="department in supportedDepartments" v-bind:key="department.id" @click="selectDepartment(department)">
            <h2>{{ department.department }}</h2>
            <p>Station ID: {{ department.station_number }}</p>
            <hr>
      </div>
    </div>
    <div class="departmentConfirmContainer" v-if="showDepartmentConfirm">
      <center>
        <div class="departmentConfirmMessage">
          <h1>{{selectedDepartmentInfo.department}}</h1>
          <h2 id="stationID">Station ID: {{selectedDepartmentInfo.station_number}}</h2>
          <v-btn @click="addDepartmentToWatchlist()" class="departmentConfirmButton" depressed color="primary">CONTINUE</v-btn>
          <br>
          <v-btn @click="departmentConfirmBackButton()" class="ma-2 backButton" color="orange darken-2" dark><v-icon darkleft>mdi-arrow-left</v-icon>Back</v-btn>
        </div>
      </center>
    </div>
    <v-snackbar :color="snackbar.color" v-model="snackbar.show" timeout="3000">
      {{ snackbar.message }} 
      <v-btn text @click="snackbar.show = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
// import { set } from 'vue/types/umd';
export default {
  data: () => ({
    supportedAreas: [],
    serviceList: ["All", "Fire", "Medical", "Other"],
    supportedDepartments: [],
    loading: false,
    showSelector: true,
    showDepartments: false,
    valid: false,
    countySelected: null,
    serviceSelected: "All",
    areaIDlookupArray: [],
    selectedDepartmentID: null,
    showDepartmentConfirm: false,
    selectedDepartmentInfo: {},
    snackbar: {
      show: false,
      message: null,
      color: "primary",
    },
    selectorRules: [
      v => !!v || 'Field is Required',
    ]
  }),
  name: 'App',

  components: {
  },

  created(){
      if (!localStorage.username){
      localStorage.removeItem('token');
      this.$router.push('login');
      return
    }
    this.getSupportedArea();
    this.countySelected = localStorage.areaName;
  },
  methods: {
    error(message){
      this.snackbar.show = true;
      this.snackbar.message = message;
      this.snackbar.color = "error";
    },
    async getSupportedArea(){
      this.loading = true;
      const response = await fetch(localStorage.apiURL + "/app/area-supported", {
        method: "GET",
        headers: {"deviceID": localStorage.token, "tokenID": localStorage.tokenID},
      });

      if (!response.ok){
        this.loading = false;
        this.error("api returned " + response.status);
        return
      }

      let data = await response.json();

      if (!data.success){
        this.loading = false;
        this.error(data.msg);
        return
      }
      this.supportedAreas = data.areaArray;
      this.areaIDlookupArray = data.area;

      this.loading = false;
    },
    async getDepartments(county, service){

      this.loading = true;
      let areaID = this.areaIDlookupArray[this.supportedAreas.indexOf(county)].area_id;

      const departmentLookupRequest = await fetch(localStorage.apiURL + "/app/" + areaID + "/departments-supported/" + service, {
        method: "GET",
        headers: {"deviceID": localStorage.token, "tokenID": localStorage.tokenID}
      })

      if (!departmentLookupRequest.ok){
        this.loading = false;
        this.error("api returned " + departmentLookupRequest.status);
        return;
      }

      let departmentLookupResponse = await departmentLookupRequest.json();

      if (!departmentLookupResponse.success){
        this.loading = false;
        this.error(departmentLookupResponse.msg);
        return;
      }
      this.supportedDepartments = departmentLookupResponse.departments;
      
      this.loading = false;

      if (this.supportedDepartments.length == 0){
        this.error("No Supported " + service + " Agencys in " + county);
        return
      }
      this.showDepartments = true;
      this.showSelector = false;
    },
    goBack(){
      history.back();
    },
    selectDepartment(department){
      this.selectedDepartmentInfo = department;
      this.showDepartments = false;
      this.showDepartmentConfirm = true;
      window.scrollTo(0,0);
    },
    departmentConfirmBackButton(){
      this.showDepartmentConfirm = false;
      this.showDepartments = true;
      this.selectedDepartmentInfo = null;
      window.scrollTo(0,0);
    },
    async addDepartmentToWatchlist(){
      this.loading = true;
      const newDepartmentWatchlistRequest = await fetch(localStorage.apiURL + "/app/watchlist/new/department", {
        method: "POST",
        headers: {"Content-Type": "application/json", "deviceID": localStorage.token, "tokenID": localStorage.tokenID}, 
        body: JSON.stringify({
          item: this.selectedDepartmentInfo.department
        })
      })
      if (!newDepartmentWatchlistRequest.ok){
        this.loading = false;
        this.error("api returned " + newDepartmentWatchlistRequest.status);
        return;
      }
      const newDepartmentWatchlistData = await newDepartmentWatchlistRequest.json();

      if (!newDepartmentWatchlistData.success){
        this.loading = false;
        this.error(newDepartmentWatchlistData.msg);
        return;
      }
      const newWatchlistID = newDepartmentWatchlistData.watchlist_id;
      
      this.$router.push({path: 'watchlist-edit', query: {id: newWatchlistID}});
      this.loading = false;
    }
  },
};
</script>

<style scoped>
@media screen and (max-width: 1500px) {
  #areaAndServiceSelector {
    margin-top: 80px;
    margin-left: 20px;
    margin-right: 20px;
    align-content: center;
  }
}
@media screen and (min-width: 1500px) {
  #areaAndServiceSelector {
    margin-top: 200px;
    align-content: center;
    width: 40%
  }
}
#signup-header {
  text-align: center;
}
#submit-button {
  margin-bottom: 25px;
  width: 100px;
}

.watchlistItems{
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 10px;
  user-select: none;
}
.watchlistItems:hover{
  background-color: rgb(209, 209, 209);
}

p{
  margin: 0;
}

.departmentConfirmMessage{
  margin-top: 100px;
  margin-left: 10px;
  margin-right: 10px;
}

.departmentConfirmContainer{
  margin-top: 40px;
}

.departmentConfirmButton{
  margin-top: 25px;
  margin-bottom: 70px;
  width: 150px;
}
.backButton{
  margin-top: 25px;
}
#stationID{
  margin-top: 20px;
}
</style>
